import { MigrationRule } from "./migrationRule.js";
import { moveColorAttributes } from "./moveColorAttributes.js";

export default [moveColorAttributes] as MigrationRule[];
